import { createAction } from 'redux-actions';

export const toggleSidebarNav = createAction('TOGGLE_SETTINGS_SIDEBAR_NAV');
